import React from "react";
import PracticsQuestionTopics from "../../../topics/PracticsQuestionTopics";


function DiagramQuestionChemTopics() {
  return (
    <>

      <PracticsQuestionTopics subject="chemistry" type="diagrambasedquestions" />

    </>
  );
}

export default DiagramQuestionChemTopics;